import AddApptCard from 'src/components/AddApptCard/AddApptCard';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';
import { FrameworkActionCreator, MenusActionCreator, AdditionalServicesActionCreator, AppointmentActionCreator, WebOpsActionCreator, CustomerActionCreator } from 'src/store/states';

const mapStateToProps = (state: IStoreState) => ({
    viewMode: state.Framework.viewMode,
    appointment: state.Appointment,
    selectedVehicle: state.Vehicles.selectedVehicle !== undefined ? state.Vehicles.selectedVehicle : '',
    vehicles: state.Vehicles.vehicles,
    specProfile: state.Framework.specProfile,
    store: state.Framework.store,
    branch: state.Framework.branch,
    additionalServices: state.AdditionalServices,
    apptVin: state.Appointment.ApptVeh.vin,
    showWeOwes: state.Specs.specs?.showWeOwes,
    showOEMRecall: state.Specs.specs?.showOEMRecall,
    showPrvRecom: state.Specs.specs?.showPrvRecom,
    inquiryInvoked: state.AdditionalServices.allServices.inquiryInvoked,
    menusReturnCode: state.Menus.allMenus.returnCode,
    theme: state.Framework.theme,
    locale: state.Framework.locale,
    myGMRewardsLaunched: state.Specs.specs?.myGMRewardsLaunched,
    gmMemberErr: state.Customer.gmMemberErr,
});

const mapDispatchToProps = {
    clearMainPanes: FrameworkActionCreator.clearMainPanes,
    pushToMainPanes: FrameworkActionCreator.pushToMainPane,
    setViewMode: FrameworkActionCreator.acSetViewMode,
    getMenus: MenusActionCreator.GetMenus,
    getAdditionalServices: AdditionalServicesActionCreator.GetAdditionalServices,
    updateApptVehicle: AppointmentActionCreator.UpdateApptVehicle,
    getApptOps: WebOpsActionCreator.GetApptOps,
    clearAdditionalServices: AdditionalServicesActionCreator.ClearAdditionalServices,
    clearMenusState: MenusActionCreator.ClearMenusState,
    addLogEntry: FrameworkActionCreator.addLogEntry,
    gmMemberSearch: CustomerActionCreator.GMMemberSearch,
    setApptHistId: AppointmentActionCreator.SetApptHistId,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AddApptCard);